import { ComponentProps } from "react"

type CheckboxInputProps = ComponentProps<'input'>

export function CheckboxInput(props: CheckboxInputProps) {
    return (
        <input
            type="checkbox"
            className={`cursor-pointer size-4 outline-hidden appearance-none 
                ring-0 ring-transparent ring-offset-transparent rounded-sm shadow-sm border 
                text-ochre_accent focus:outline-hidden focus:ring-offset-transparent focus:ring-transparent`}
            {...props} />
    )
}

interface CheckboxItemProps extends ComponentProps<'input'> {
    name: string,
    value: string,
    label: string,
    defaultChecked?: boolean
}

export function CheckboxItem({ name, value, label, defaultChecked, ...props }: CheckboxItemProps) {
    return (
        <label className="flex items-center gap-2 cursor-pointer">
            <input
                type="checkbox"
                name={name}
                value={value}
                defaultChecked={defaultChecked}
                onChange={(e) => {
                    if (e.target.checked) {
                        const checkboxes = document.querySelectorAll(`input[name ="${name}"]`)
                        checkboxes.forEach((cb) => {
                            if (cb !== e.target) (cb as HTMLInputElement).checked = false;
                        })
                    }
                }}
                className={`size-4 outline-hidden appearance-none 
                    ring-0 ring-transparent ring-offset-transparent rounded-sm 
                    shadow-sm border text-ochre_accent 
                    focus:outline-hidden focus:ring-offset-transparent focus:ring-transparent`}
                {...props} />
            <span>{label}</span>
        </label>
    )
}
